import { getDiffTime } from '@/helpers/date';

export interface ChimeraContractInfo {
  id: string;
  startDate: string;
  expirationDate: string;
}

export class ChimeraContractModel {
  id: number;

  startDate: Date;

  expirationDate: Date;

  constructor(chimeraContract: ChimeraContractInfo) {
    this.id = +chimeraContract.id;
    this.startDate = new Date(chimeraContract.startDate);
    this.expirationDate = new Date(chimeraContract.expirationDate);
  }

  get remainingContractPeriod() {
    return getDiffTime(this.expirationDate, new Date());
  }

  get contractAge() {
    return getDiffTime(new Date(), this.startDate);
  }

  get totalContractTime() {
    return getDiffTime(this.expirationDate, this.startDate);
  }
}
